import "./bridge.scss";
import { Grid, InputAdornment, MenuItem, OutlinedInput, Select, Zoom } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useWeb3Context } from "src/hooks";
import { getAddresses } from "src/constants";
import { Skeleton } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { formatValue, formatValueDigits, trim } from "src/helpers";
import { IPendingTxn, isPendingTxn, txnButtonText } from "src/store/slices/pending-txns-slice";
import { IReduxState } from "src/store/slices/state.interface";
import { getChainName, getDestChainID } from "src/helpers/get-chains";
import MNTIcon from "../../assets/tokens/MNT.png";
import SwapIcon from "../../assets/icons/arrow-swap.svg";
import { switchNetworkHelper } from "src/helpers/switch-network";
import { JsonRpcProvider, StaticJsonRpcProvider } from "@ethersproject/providers";
import { getMainnetURI } from "src/hooks/web3/helpers";
import { ethers } from "ethers";
import { MNTSTokenContract } from "src/abi";
import { warning } from "src/store/slices/messages-slice";
import { bridge_mnts } from "src/store/slices/bridge-thunk";
import { fetchAccountSuccess } from "src/store/slices/account-slice";

export default function Bridge() {
    const dispatch = useDispatch();
    const { provider, address, connect, connected, chainID, checkWrongNetwork } = useWeb3Context();
    const addresses = getAddresses(chainID);

    const [quantity, setQuantity] = useState<string>("");
    const [destMntsBalance, setDestMntsBalance] = useState<string>("");
    const [recipient, setRecipient] = useState<string>(address);
    const [changeRecipient, setChangeRecipient] = useState<boolean>(false);

    const [bridgeText, setBridgeText] = useState<string>("Bridge");
    const [bridgeBtnDisabled, setBridgeBtnDisabled] = useState<boolean>(false);

    const destChainID = getDestChainID(chainID);

    const isAppLoading = useSelector<IReduxState, boolean>(state => state.app.loading);
    const mntsBalance = useSelector<IReduxState, string>(state => {
        return state.account.balances && state.account.balances.mnts;
    });
    const pendingTransactions = useSelector<IReduxState, IPendingTxn[]>(state => {
        return state.pendingTransactions;
    });

    const setPositiveQuantity = (value: string) => {
        value = value.replace(/[^\d.]/g, "");
        Number(value) >= 0 ? setQuantity(value) : setQuantity("");
        setBridgeBtnDisabled(false);
        setBridgeText("Bridge");
    };

    const setMax = () => {
        setQuantity(trim(Number(mntsBalance), 4));
    };

    const changeNetwork = async () => {
        if (connected) {
            await switchNetworkHelper(destChainID);
            window.location.reload();
        }
    };

    const onBridge = async () => {
        if (await checkWrongNetwork()) return;
        if (quantity === "" || parseFloat(quantity) === 0) {
            dispatch(warning({ text: "Please enter a valid amount" }));
        } else {
            setBridgeBtnDisabled(true);
            await dispatch(
                bridge_mnts({
                    value: String(quantity),
                    recipient,
                    destChainID,
                    address,
                    provider,
                    networkID: chainID,
                }),
            );
            setBridgeBtnDisabled(false);
        }
    };

    // useEffect(() => {
    //     const getDestMNTSBalance = async () => {
    //         const destAddresses = getAddresses(destChainID);
    //         const destProvider = new JsonRpcProvider(getMainnetURI(destChainID));
    //         const destMntsContract = new ethers.Contract(destAddresses.MNTS_ADDRESS, MNTSTokenContract, destProvider);
    //         const destMntsAmount = await destMntsContract.balanceOf(recipient);
    //         setDestMntsBalance(ethers.utils.formatUnits(destMntsAmount, "ether"));
    //     };
    //     if (destChainID && recipient && connected) {
    //         getDestMNTSBalance();
    //     }
    // }, [destChainID, recipient]);

    // useEffect(() => {
    //     const updateMNTSBalance = async () => {
    //         const mntsContract = new ethers.Contract(addresses.MNTS_ADDRESS, MNTSTokenContract, provider);
    //         const mntsAmount = await mntsContract.balanceOf(address);
    //         let balanceObj: any = {};
    //         balanceObj["mnts"] = ethers.utils.formatUnits(mntsAmount, "ether");
    //         dispatch(
    //             fetchAccountSuccess({
    //                 balances: balanceObj,
    //             }),
    //         );
    //     };
    //     if (address && connected) {
    //         updateMNTSBalance();
    //     }
    // }, [address]);

    return <div className="bridge-view"></div>;
}
